import type { RequestLeaveItem } from "views/RequestLeave/types"

import { RequestLeaveStatus } from "__generated__/graphql"
import RequestLeaveReviewButtons, { RequestLeaveReviewType } from "views/RequestLeave/RequestLeaveReviewButtons"

type Props = {
  leave: RequestLeaveItem
  onReview: (leave: RequestLeaveItem, type: RequestLeaveReviewType) => void
  reviewerDiscordId?: string
}

export const canReviewRequestLeave = (leave: RequestLeaveItem, reviewerDiscordId?: string) =>
  Boolean(reviewerDiscordId && leave.approver?.discordId === reviewerDiscordId)

const RequestLeaveReviewActions = ({ leave, onReview, reviewerDiscordId }: Props) => {
  if (!canReviewRequestLeave(leave, reviewerDiscordId)) return null

  const disabled = leave.status !== RequestLeaveStatus.AwaitingApproval

  return <RequestLeaveReviewButtons disabled={disabled} onReview={(type) => onReview(leave, type)} />
}

export default RequestLeaveReviewActions
